import { css } from '@spectrum-web-components/base';
const styles = css`
    :host{--spectrum-asset-folder-background-color:var(--system-asset-folder-background-color);--spectrum-asset-file-background-color:var(--system-asset-file-background-color);--spectrum-asset-icon-outline-color:var(--system-asset-icon-outline-color)}
`;
export default styles;